module.exports = __webpack_public_path__ + "img/mg.29f6c209.png";